export default "__VITE_ASSET__DRF$MQQt__"